var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoInfo = function SvgIcoInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface23148900"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D6D8D1",
    d: "M 44 24 C 44 35.046875 35.046875 44 24 44 C 12.953125 44 4 35.046875 4 24 C 4 12.953125 12.953125 4 24 4 C 35.046875 4 44 12.953125 44 24 Z M 44 24 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M 22 22 L 26 22 L 26 33 L 22 33 Z M 26.5 16.5 C 26.5 17.878906 25.378906 19 24 19 C 22.621094 19 21.5 17.878906 21.5 16.5 C 21.5 15.121094 22.621094 14 24 14 C 25.378906 14 26.5 15.121094 26.5 16.5 Z M 26.5 16.5 "
  }))));
};
export default SvgIcoInfo;